import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import {timeSelect15MinsInterval} from "../../../../utils/select-fields";
import R from "ramda";

const { object, string } = PropTypes;

const NestedItems = ({ filterKey, onChange, selectedValue, title, list }) => {
  return (
    <div style={{ overflow: 'auto' }}>
      <ReactSelect
        name={filterKey}
        style={{ fontSize: '14px', zIndex: '0' }}
        menuStyle={{ height: '150px' }}
        multi
        layout={"l-paper-right multi-select"}
        options={list.map(v => ({ label: v.title, value: v.value }))}
        value={selectedValue}
        onChange={value => onChange({ value, filterKey })}
        placeholder="Please enter/select time"
        scrollMenuIntoView
        clearable={false}
      />
    </div>
  );
}

NestedItems.propTypes = {
  filter: object,
  selectedValue: string,
};

export default NestedItems;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/nestedItem.jsx